import { render, staticRenderFns } from "./ResourcesCertificates.vue?vue&type=template&id=1fc9849d&"
import script from "./ResourcesCertificates.vue?vue&type=script&lang=js&"
export * from "./ResourcesCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports